import React from "react";
import styled from "styled-components";
import { MarginProps } from "styled-system";
import { StepItemDataProps, StepItemStyledProps } from ".";
import { colorSelector } from "../../utils/ColorSelector";
import { Box } from "../Box";
import { CircularIcon } from "../CircularIcon";
import { Flex } from "../Flex";
import { Text } from "../Text";

const StyledText = styled(Text)`
  word-wrap: break-word;
  & > a {
    text-decoration: none;
    color: ${colorSelector("accent")};
  }
`;

export const StepItem: React.FC<StepItemDataProps & StepItemStyledProps & MarginProps> = ({
  icon,
  iconText,
  text,
  title,
  circularSize,
  fontSize,
  titleFontSize,
  color,
  zIndex,
  width,
  iconWidth,
  iconMb,
  align,
  ...restProps
}) => (
  <Flex
    data-testid="StepItem"
    flexDirection="column"
    alignItems={align === "center" ? "center" : "flex-start"}
    width={width}
    zIndex={zIndex}
    {...restProps}
  >
    <CircularIcon
      bg={color}
      borderColor={color}
      width={circularSize}
      height={circularSize}
      mb={iconMb}
      align={align === "left" ? "left" : "center"}
    >
      {icon && <img width={iconWidth} src={icon} alt="stepIcon" />}
      {iconText && (
        <Text color="white" fontSize={5}>
          {iconText}
        </Text>
      )}
    </CircularIcon>
    {title && (
      <Box width="100%">
        <Text pr={3} fontSize={titleFontSize || fontSize} my={1} lineHeight="28px">
          {title}
        </Text>
      </Box>
    )}
    {align !== "center" ? (
      <Box width="100%">
        <StyledText
          pl={0}
          pr={3}
          textAlign={align}
          fontSize={fontSize}
          lineHeight="28px"
          my={0}
          dangerouslySetInnerHTML={{ __html: text }}
        />
      </Box>
    ) : (
      <StyledText pl={3} pr={3} fontSize={fontSize} lineHeight="28px" my={0} dangerouslySetInnerHTML={{ __html: text }} />
    )}
  </Flex>
);

StepItem.defaultProps = {
  iconWidth: 40,
  align: "center",
  iconMb: 0,
};
